import React from 'react'
import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'

import styles from './style.module.scss'
import nodataArt from '@assets/images/no-data.svg'

const MyImage = dynamic(() => import('@shared/components/myImage'))

const NoData = (props) => {
  return (
    <div className={`${styles.NoData} my-2 my-md-3  text-center`}>
      <h3 className={`text-capitalize ${props?.description ? 'mb-0' : ''}`}>{props?.title || 'No Data Found'}</h3>
      {props?.description && <p>{props?.description}</p>}
      <div className={`${styles.artwork} mx-auto mb-2`}>
        <MyImage src={nodataArt} alt="user" />
      </div>
    </div>
  )
}
NoData.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  description: PropTypes.oneOfType([PropTypes.string])
}

export default NoData
